var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayByLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9453 16.9336C14.3748 17.5077 14.9227 17.9827 15.5519 18.3265C16.1811 18.6703 16.8768 18.8747 17.592 18.9259C18.3071 18.9771 19.0249 18.8739 19.6967 18.6233C20.3684 18.3728 20.9784 17.9806 21.4853 17.4736L24.4853 14.4736C25.3961 13.5305 25.9001 12.2675 25.8887 10.9566C25.8773 9.64557 25.3514 8.39151 24.4244 7.46447C23.4974 6.53743 22.2433 6.01158 20.9323 6.00019C19.6213 5.9888 18.3583 6.49277 17.4153 7.40356L15.6953 9.11356",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9436 14.9328C17.5141 14.3587 16.9662 13.8837 16.337 13.5399C15.7078 13.1961 15.0121 12.9917 14.2969 12.9405C13.5818 12.8893 12.864 12.9925 12.1922 13.2431C11.5205 13.4936 10.9104 13.8858 10.4036 14.3928L7.40356 17.3928C6.49277 18.3359 5.9888 19.5989 6.00019 20.9098C6.01158 22.2208 6.53743 23.4749 7.46447 24.4019C8.39151 25.329 9.64557 25.8548 10.9566 25.8662C12.2675 25.8776 13.5305 25.3736 14.4736 24.4628L16.1836 22.7528",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayByLink);
export default __webpack_public_path__ + "static/media/pay_by_link.9f3562573d151f89d91bc3ad230841ad.svg";
export { ForwardRef as ReactComponent };